import { styled } from "styled-components";

export const ValidationError = styled.p`
  color: #e43a15;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`;
